import { ISmartGroup } from "../../engine/DataModels/ISmartPattern";
import biblio_200_220 from "../../assets/patterns/biblio-200-220-3.3.png";
import biblio_221_250 from "../../assets/patterns/biblio-221-250-3.3.png";

const GKEY = "3.3";
export const BiblioGroup3_3: ISmartGroup = {
    key: GKEY,
    modulesByInterval: [
        {
            groupKey: GKEY,
            itvalIdx: 0,
            icon: biblio_200_220,
            zones: [
            { Ac:3, SWD: [0,0] },
            { Ac:1 }, 
            { Ac:1 }, 
            { Ac:2, SWD: [0] }, 
            { Ac:1 }, 
            { Ac:1 }
        ]},
        {
            groupKey: GKEY,
            itvalIdx: 1,
            icon: biblio_221_250,
            zones: [
            { Ac:3, SWD: [1,1,1] },
            { Ac:2 }, 
            { Ac:1 }, 
            { Ac:2, SWD: [0] }, 
            { Ac:1 },
            { Ac:1 }
        ]}
    ]
}